/* eslint-disable react/no-unused-prop-types */
import { useDebounce } from '@uidotdev/usehooks'
import { useEffect, useState } from 'react'

import { ControlledInput } from './ControlledInput'

interface IProps {
  id: string
  containerClassName?: string
  className?: string
  type: string
  label: string
  placeholder: string
  showLabel?: boolean
  value: any
  disabled?: boolean
  hideErrors?: boolean
  inputRef?: any
  delay?: number
  onChange: (e: any) => void
}

export const ControlledInputDebounced = (props: IProps) => {
  const [value, setValue] = useState(props.value)
  const debouncedParams = useDebounce(value, props?.delay || 600)

  useEffect(() => {
    setValue(props.value)
  }, [props.value])

  useEffect(() => {
    props.onChange({ target: { value: debouncedParams } })
  }, [debouncedParams])

  return <ControlledInput {...{ ...props, value, onChange: (e) => setValue(e.target.value) }} />
}
